const DIGITAL_OCEAN_API_URL = 'https://services.barkyn.com/v0';

const getDigitalOceanHeaders = () => {
    const headers = new Headers();
    headers.append("X-API-KEY", 'GQk2ocGpPpjN1FMzvjM5C0tXjLL84OVIeNMrDebU');
    return headers;
}

const digitalOceanExecuteApiRequest = async (url, options = {}) => {
    try {
        options.headers = getDigitalOceanHeaders();
        options.redirect = 'follow'
        const response = await fetch(url, options);

        if (!response.ok) {
            throw new Error(`API request failed with status ${response.status}`);
        }
        if(options.method === 'DELETE') return;
        
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(`Error executing API request: ${error.message}`);
        throw error; // re-throw the error so it can be caught and handled by the calling code
    }
};

const getDigitalOceanCustomerDogs = async (customerId) => {
    try {
        const url = `${DIGITAL_OCEAN_API_URL}/customer/${customerId}/dogs`;

        const options = {
            method: 'GET',
        };

        const response = await digitalOceanExecuteApiRequest(url, options);

        return response?.data || [];
    } catch (error) {
        console.error(`Error getting customer dogs: ${error.message}`);
        throw error;
    }
}

const updateDigitalOceanDog = async (dogId, dogData) => {
    try {
        const url = `${DIGITAL_OCEAN_API_URL}/dogs/${dogId}`

        const options = {
            method: 'PATCH',
            body: dogData
        };
        const response = await digitalOceanExecuteApiRequest(url, options);
        return response?.data || []
    } catch (error) {
        console.error(`Error updating dog: ${error.message}`);
        throw error;
    }
}

const createDigitalOceanDog = async (dogData) => {
    try{
        const url = `${DIGITAL_OCEAN_API_URL}/dogs`
        const options = {
            method: 'POST',
            body: dogData
        }

        const response = await digitalOceanExecuteApiRequest(url, options)
        return response?.data || [];
    } catch(error) {
        console.error(`Error creating dog: ${error.message}`)
        throw error;
    }
}

const deleteDigitalOceanDog = async (dogId) => {
    try{
        const url = `${DIGITAL_OCEAN_API_URL}/dogs/${dogId}`
        const options = {
            method: 'DELETE',
        }

        await digitalOceanExecuteApiRequest(url, options)

    } catch(error){
        console.error(`Error removing dog: ${error.message}`)
        throw error;
    }
}